export const YEAR = '2022'